/*****************
 * Global events *
 *****************/

$('body').on('click', '.clickable-loadable-element', function (e) {
    iris.setButtonLoading($(e.target));
});

$('body').on('click', '#request-callback-button', function () {
    $.ajax({
        method: 'POST',
        url: '/portfolio/callback',
        data: $('form#cb-request-form').serialize(),
        success: function (response) {
            $('#callback-ajax-validation').removeClass('alert-danger');
            $('#callback-ajax-validation').addClass('alert-success');
            $('#callback-ajax-validation').html('Thank you! We will be in touch soon.');
            $('#callback-ajax-validation').show();
            $('#cb-request-form input').removeClass('has-danger');
            iris.unsetButtonLoading($('#request-callback-button'));
            $("form#cb-request-form")[0].reset();
        },
        error: function (response) {
            var message = 'Unfortunately your request could not be recorded';

            if (response.status === 422) {
                var jsonResponse = $.parseJSON(response.responseText);

                $.each(jsonResponse.errors, function (field, message) {
                    $('#cb-request-form input[name=' + field + ']').addClass('has-danger');
                });

                message = 'Please provide your contact details.';
            }

            $('#callback-ajax-validation').removeClass('alert-success');
            $('#callback-ajax-validation').addClass('alert-danger');
            $('#callback-ajax-validation').html(message);
            $('#callback-ajax-validation').show();
            iris.unsetButtonLoading($('#request-callback-button'));
        }
    });
});

// change opacity of header on scroll
$(window).scroll(function () {
    if ($(this).scrollTop() > 10) {
        $(".navbar-dark").css(
            {
                "background-color": "rgba(42, 44, 45, 0.95)",
                "border-bottom-color": "rgba(41, 43, 44, 1.0)"
            }
        );
    } else {
        $(".navbar-dark").css(
            {
                "background-color": "rgba(42, 44, 45, 0.2)",
                "border-bottom-color": "rgba(41, 43, 44, 1.0)"
            }
        );
    }
});

// callback request form
$(".pocminimize").click(function () {
    if ($(".cbrequest").is(":visible")) {
        $(".cbrequest").animate({height: '0px'}, function () {
            $(this).hide();
        });
        $(".cbheader i.angle").removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
        $(".cbwrapper").css("width", 'auto');
    } else {
        $(".cbrequest").show().animate({height: '525px'});
        $(".cbheader i.angle").removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
        $(".cbwrapper").css("width", '25%');
    }
});

$("#question-request-callback").click(function (e) {
    e.preventDefault();
    $(".pocminimize").click();
});

/**************************
 * Globally scoped methods *
 ***************************/

// ----------------------------------------------------------------
// Count To (counters) - used for ticket counters & videowall
// @see: https://github.com/mattboldt/typed.js
//       (this library is imported via app.js)
// ----------------------------------------------------------------
let $countTos = $('[data-toggle="count-to"]');

if ($countTos.length > 0) {
    initCountTo = function () {
        $countTos.each(function () {
            let $this = $(this),
                delay = $this.data('delay') || 0;
            $this.waypoint(function () {
                setTimeout(function () {
                    $this.countTo({
                        onComplete: function () {
                            $this.addClass('count-to-done');
                        },
                        formatter: function (value, options) {
                            let v = value.toFixed(options.decimals);
                            if (v === '-0') {
                                v = '0';
                            }
                            return v;
                        },
                    });
                }, delay);
                this.destroy();
            }, {
                offset: '90%',
            });
        });
    };
}

/**
 * helper function to populate an simple selectbox with values from an
 * url that returns id/text value pairs
 */
$.fn.populateFromUrl = function (options) {
    var settings = $.extend({
        // These are the defaults.
        url: '',
        disableIfEmpty: false,
        emptyText: 'No choices available'
    }, options);

    this.each(function () {
        var $this = $(this);
        $.getJSON(settings.url, {}, function (r) {
            var options = '';
            $this.removeAttr('disabled');
            for (var i = 0; i < r.length; i++) {
                options += '<option value="' + r[i].Id + '">' + r[i].Text + '</option>';
            }
            if (r.length === 0) {
                options += '<option value="">' + settings.emptyText + '</option>';
                if (settings.disableIfEmpty) {
                    $this.prop('disabled', 'disabled');
                }
            }
            $this.html(options);
        }).fail(function () {
            var options = '<option value="">Error retrieving data...</option>';
            $this.html(options).prop('disabled', 'disabled');
        });
    });
};

/**
 * helper function to grab part of the address string
 */
$.fn.getAddressPartFromUrl = function (options) {
    var settings = $.extend({
        // These are the defaults.
        url: '',
        part: 0
    }, options);

    this.each(function () {
        var $this = $(this);
        $.getJSON(settings.url, {}, function (r) {
            var address = r[0].Text;
            var addrParts = address.split(", ");
            if (settings.part === 1) {
                addrParts[1] = addrParts[1].replace(/\s/g, '');
            }
            if (settings.part === 0) {
                var re = /(.*?)([0-9]+)$/;
                var streetParts = re.exec(addrParts[0]);
                addrParts[0] = streetParts[2];
            }


            $this.val(addrParts[settings.part]);
        }).fail(function () {
            var address = 'Error!';
            $this.val(address);
        });

    });
};

/**
 * helper function to grab part of the address string
 */
$.fn.validateAddress = function (options) {
    var settings = $.extend({
        // These are the defaults.
        url: '/lookup/addrvalidate/',
        get: '',
        customer: ''
    }, options);
    this.each(function () {
        var $this = $(this);
        $.getJSON('/lookup/locations/' + settings.customer, {}, function (s) {
            var address = s[0].Text;
            var addrLookup = address.replace(/,\s/g, "/");
            $.getJSON(settings.url + addrLookup, {}, function (r) {
                var returnvalue = '';
                if (settings.get === 'postalcode') {
                    returnvalue = r.postalcode;
                } else if (settings.get === 'housenumber') {
                    returnvalue = r.housenumber;
                } else {
                    returnvalue = r.extension;
                }
                $this.val(returnvalue);
            }).fail(function () {
                var address = 'Error!';
                $this.val(address);
            });
        }).fail(function () {
            var address = 'Error!';
            $this.val(address);
        });
    });
};